import React, {Component} from 'react';
import {Popup, Button, Input, List, Header, Form, TextArea} from 'semantic-ui-react';

class ShoppingListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quantity: this.props.quantity,
            observations: this.props.observations,
            quantity_error: false
        }
    }

    handleQuantityChange = (event) => {
        this.setState({quantity:event.target.value});
        // eslint-disable-next-line
        let quantity = parseInt(event.target.value) ? parseInt(event.target.value):1;
        if (event.target.value.trim() === '') {
            this.setState({quantity_error: true})
        } else {
            this.setState({quantity_error: false})
        }
        this.props.callbackClick({id:this.props.id, action:'quantity', quantity})
    };

    handleNotesChange = (event) => {
        this.setState({observations:event.target.value});
        this.props.callbackClick({id:this.props.id, action:'observations', observations:event.target.value})
    };

    render() {
        return (
            <List.Item style={{marginBottom:'3px'}}>
                <List.Content floated='left' verticalAlign='middle'>
                    <div>
                        <Popup content='Borrar de la lista' trigger={<Button size='tiny' onClick={()=>this.props.callbackClick({id:this.props.id, action:'delete'})} icon='trash'></Button>} />
                        <Input size='mini' min={1} ref={this.inputRef} type='number' placeholder='Cant.' onChange={this.handleQuantityChange} style={{width:'6.3em', marginRight:'3px'}} value={this.state.quantity} error={this.state.quantity_error}/>
                        <Popup trigger={<Button size='tiny' icon='sticky note'></Button>} flowing hoverable>
                            <Header as='h4'>Notas</Header>
                            <Form>
                                <TextArea placeholder='Escribe algunas observaciones' onChange={this.handleNotesChange} value={this.state.observations}/>
                            </Form>
                        </Popup>
                    </div>
                </List.Content>
                <List.Content>
                    <List.Header as='h4'><strong>{this.props.name}</strong></List.Header>
                    <br/>
                </List.Content>
                <List.Content>
                    <List.Header as='h4'>Notas:</List.Header>
                    <List.Description style={{whiteSpace: 'pre-line'}}>{this.state.observations}</List.Description>
                </List.Content>
            </List.Item>
        );
    }
}

export default ShoppingListItem;



// WEBPACK FOOTER //
// ./src/components/inventories/ShoppingListItem.js